(() => {
  const initGuiaTallas = (root = document) => {
    const sections = root.querySelectorAll('[data-rg-guia-tallas]');

    sections.forEach((section) => {
      if (section.dataset.rgTabsInit === 'true') return;

      section.dataset.rgTabsInit = 'true';

      section.addEventListener('click', (event) => {
        const selectedTab = event.target.closest('[data-rg-tab]');

        if (!selectedTab || !section.contains(selectedTab)) return;

        const selectedHandle = selectedTab.dataset.rgTab;

        section.querySelectorAll('[data-rg-tab]').forEach((tab) => {
          const isActive = tab.dataset.rgTab === selectedHandle;

          tab.classList.toggle('rg-guia-tallas__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        section.querySelectorAll('[data-rg-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.rgPanel !== selectedHandle;
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGuiaTallas();
    });
  } else {
    initGuiaTallas();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initGuiaTallas(event.target);
  });
})();